class AutoPlayVimeo {
	constructor($dom, isAutoPlay){
		this.dom 	= $dom;
		this.id 	= $dom.getAttribute("data-movie-id");
		//console.log(this);
		
		this.options = {
			url: `https://vimeo.com/${this.id}`,
			byline: false, // 投稿者部分の表示
			portrait: false, // 左上のVimeoのマークの表示
			title: false, // タイトルの表示
			autoplay: isAutoPlay,
			controls: 0,
			muted: 1,
			pip: 0,
			loop: 1,
			playsinline: 1
		}
		this.player = new Vimeo.Player($dom, this.options);
	}
}


export let autoPlayVimeo = {
	videos: [],
	arry: [],
	observer: null,
	init: function(){
		autoPlayVimeo.videos = document.querySelectorAll(".movie [data-movie-id]");
		autoPlayVimeo.videos.forEach( ($v, index) => {
			let isAutoPlay = parseInt( $v.getAttribute("data-is-autoplay") );
			autoPlayVimeo.arry[index] = new AutoPlayVimeo($v, isAutoPlay);
		});
		autoPlayVimeo.setObserver();
	},
	setObserver: function(){
		//Videoのサムネイル
		if( autoPlayVimeo.videos.length > 0 ){
			let movieOptions = {
				root: null,
				rootMargin: '0px',
				threshold: 0
			}
			autoPlayVimeo.observer = new IntersectionObserver(autoPlayVimeo.checkVideoStart, movieOptions);
			autoPlayVimeo.videos.forEach( item => {
				autoPlayVimeo.observer.observe(item);
			});
		}
	},
	checkVideoStart: function(items){
		items.forEach( (item, index) => {
			let $target = autoPlayVimeo.arry[index];
			if( item.isIntersecting ){
				$target.player.play().then( ()=> {
					console.log("start Play:", autoPlayVimeo.videos[index]);
					autoPlayVimeo.videos[index].setAttribute("data-is-playing", true);
				});
				
			}else{
				$target.player.pause().then( ()=> {
					console.log("pause", autoPlayVimeo.videos[index]);
					autoPlayVimeo.videos[index].setAttribute("data-is-playing", false);
				});
			}
		})
	}
}